const UNIT_KINDS = new Set(['weight', 'distance', 'elevation']);

export function getVisibleUnitKinds(entries = []) {
  return new Set(entries
    .filter(entry => entry?.isIntersecting && (entry.intersectionRatio === undefined || entry.intersectionRatio > 0))
    .map(entry => entry.target?.dataset?.unitKind)
    .filter(kind => UNIT_KINDS.has(kind)));
}
